import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ui-input',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './input.component.html',
})
export class InputComponent {
  @Input() type: 'text' | 'number' = 'text';
  @Input() placeholder: string = '';
  @Input() value: string | number = '';
  @Input() disabled = false;
  @Input() required = false;
  @Input() min?: number;
  @Input() max?: number;
  @Input() step?: number;
  @Input() label: string = '';

  @Output() valueChange = new EventEmitter<string | number>();

  uniqueId = Math.random().toString(36).substr(2, 9);

  get inputType(): string {
    return this.type;
  }

  get inputClasses(): string {
    const base = 'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm';
    const disabledClass = this.disabled ? 'bg-gray-100 cursor-not-allowed' : '';
    return `${base} ${disabledClass}`.trim();
  }

  onValueChange(newValue: string | number): void {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
}
